module.exports = __webpack_public_path__ + "img/header.a26240d4.jpg";